import $ from 'jquery';

$('body').on('change', '.control-file__value', function () {
    const $this = $(this);
    const fileContainer = $this.closest('.control-file');
    const fileLabel = fileContainer.find('.control-file__trigger');
    const fileName = $this.val().match(/[^\\/]*$/)[0];
    fileLabel.text(fileName).attr('title', fileName);
});
